import { Component } from '@angular/core';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GrupoDTO, GrupoFormDTO } from '../../../../models/grupo.model';
import { GrupoService } from '../../../../services/grupo/grupo.service';

@Component({
  selector: 'app-grupo-edit',
  templateUrl: './grupo-edit.component.html',
  styleUrl: './grupo-edit.component.scss',
  providers: [ConfirmationService, MessageService],
})
export class GrupoEditComponent {
  checked = false;
  date2: Date | undefined;
  grupos: GrupoDTO[] = [];
  first3 = 0;
  rows3 = 5;
  totalRecords = 0;
  lastfield = '';
  lastSort = '';
  options = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 120, value: 120 },
  ];
  form: GrupoFormDTO = this.createEmptyForm();
  stateOptions: any[] = [
    { label: 'Ativo', value: true },
    { label: 'Inativo', value: false },
  ];

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private grupoService: GrupoService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.grupoService.getById('/grupo/' + id).subscribe((response) => {
        this.form = {
          id: response.id,
          // codigoGrupo: response.codigoGrupo,
          nome: response.nome,
          status: response.status,
        };
      });
    }
  }

  submit() {
    if (this.form.nome === '' || this.form.nome === null) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: this.translate.instant('grupo.texts.nome_obrigatorio'),
      });
      return;
    }

    // if (this.form.codigoGrupo === null) {
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Erro',
    //     detail: 'Selecionar o campo codigo é obrigatório!',
    //   });
    //   return;
    // }

    const body: GrupoDTO = {
      nome: this.form.nome,
      // codigoGrupo: this.form.codigoGrupo,
      status: this.form.status,
    };

    this.grupoService.put('/grupo/' + this.form.id, body).subscribe({
      next: (response) => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('common.sucesso'),
          detail: this.translate.instant('grupo.texts.grupo_editado_sucesso'),
        });
        this.form = this.createEmptyForm();
        this.router.navigate(['/grupo']);
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('common.erro'),
          detail: this.translate.instant('grupo.texts.erro_ao_salvar_grupo'),
        });
      },
    });
  }

  createEmptyForm(): GrupoFormDTO {
    return {
      nome: '',
      // codigoGrupo: null,
      status: true,
    };
  }
}
